module.exports = __webpack_public_path__ + "img/bank-red.1b442e59.svg";